<div class="right-panel"
     *ngIf="allNetworkServer.length >0">
  <div class="panel-header">
    <p class="panel-title">Add Served Network Server for {{jsName}}</p>
  </div>
  <div class="panel-container createNS">
    <div class="createNS-row">
      <label class="widget-create-title">Network Server
        <i class="fa fa-info-circle info-text"></i>
      </label>

      <div class="live-search">
        <ngx-select [allowClear]="true"
                   [items]="allNetworkServer"
                   (select)="selectedNS($event)"
                   (remove)="removed($event)">
        </ngx-select>
      </div>

    </div>

    <!-- SubscriberID field has been moved to Network Server for now. So this section should  not be rendered -->
    <!--
    <div class="createNS-row" *ngIf="renderSubscriberId">
      <label class="widget-create-title">Subscriber ID
        <i class="fa fa-info-circle info-text"></i>
      </label>

      <div>
        <textarea id="subscriber_id"
               rows="2" class="widget-create-content form-control"
               [(ngModel)]="subscriberId"
               name="subscriber_id"
               #inputSubscriberId
               autocomplete="off"
               maxlength="80" size="80"></textarea>
      </div>
    </div>
    -->
    <div class="btn-area">
      <button (click)="backClicked()"
              class="custom-btn">Cancel
      </button>
      <button type="submit"
              class="custom-btn create-btn"
              [disabled]="!isEnable"
              [ngClass]="{'disable': !isEnable}"
              (click)="save()">Add
      </button>
    </div>
  </div>
</div>
